import { indexBy } from 'remeda';
import { createReducer } from 'typesafe-actions';

import { Deploy } from '@block-explorer/entities';

import { PaginatedReducerState } from '../utils';
import { getDeployByHashAsync, getPaginatedDeploysAsync } from './actions';

type State = PaginatedReducerState<Deploy>;

const initialState: State = {
  loading: false,
  error: null,
  byHash: {
    loading: false,
    error: null,
    items: {},
  },
  paginatedItems: [],
  totalItemCount: 0,
  totalPageCount: 0,
};

export default createReducer(initialState)
  .handleAction(
    getPaginatedDeploysAsync.request,
    (state, action): State => ({
      ...state,
      loading: true,
      error: null,
    })
  )
  .handleAction(
    getPaginatedDeploysAsync.failure,
    (state, action): State => ({
      ...state,
      loading: false,
      error: action.payload,
    })
  )
  .handleAction(
    getPaginatedDeploysAsync.success,
    (state, action): State => ({
      ...state,
      loading: false,
      error: null,
      paginatedItems: action.payload.data,
      byHash: {
        ...state.byHash,
        items: {
          ...state.byHash.items,
          ...indexBy(action.payload.data, (deploy) =>
            deploy.deployHash.toLowerCase()
          ),
        },
      },
      totalItemCount: action.payload.item_count,
      totalPageCount: action.payload.page_count,
    })
  )
  .handleAction(
    getDeployByHashAsync.request,
    (state, action): State => ({
      ...state,
      byHash: {
        ...state.byHash,
        loading: true,
        error: null,
      },
    })
  )
  .handleAction(
    getDeployByHashAsync.failure,
    (state, action): State => ({
      ...state,
      byHash: {
        ...state.byHash,
        loading: false,
        error: action.payload,
      },
    })
  )
  .handleAction(
    getDeployByHashAsync.success,
    (state, { payload: deploy }): State => ({
      ...state,
      byHash: {
        ...state.byHash,
        items: {
          ...state.byHash.items,
          [deploy.deployHash.toLowerCase()]: deploy,
        },
        loading: false,
        error: null,
      },
    })
  );
